export { VehicleRatings } from './VehicleRatings';
